module.exports = __webpack_public_path__ + "static/sharmadean-reid-548c25ad13d54ba5b24c85cb447eedc2.jpg";